/* ==========================================================================
   Homellence – C5 (Runde 48) · „Der Stein ist derselbe, nur das Muster
   wechselt"

   Drei Fotos derselben Badematte, eines je Muster. Das Skript macht zwei
   Dinge, mehr nicht:

   1. Es nimmt der Knopfreihe das `hidden`. Vorher steht sie nicht da -
      deshalb sieht jemand ohne JavaScript das erste Bild und keinen Knopf,
      der nichts tut.

   2. Beim Wechsel blendet es das gewaehlte Bild ein und die anderen aus.

   **Geladen wird dabei nichts.** Alle Bilder stehen im Markup und liegen
   gestapelt uebereinander; ausgeblendet wird ueber `visibility`, nicht
   ueber `display: none`. Ein Bild in einem `display: none` holt der Browser
   erst beim Einblenden - das waere genau das Nachladen beim Klick, das hier
   nicht vorkommen soll.

   Die Knoepfe aendern die gekaufte Variante nicht. Sie tragen kein
   `?variant=` in die Adresse und fassen kein Formular an: Es ist eine
   Bildansicht, kein Kauf.
   ========================================================================== */
(function () {
  'use strict';

  class HlPattern extends HTMLElement {
    connectedCallback() {
      this.choice = this.querySelector('[data-hl-pattern-choice]');
      this.shots = Array.prototype.slice.call(this.querySelectorAll('[data-hl-pattern-shot]'));
      this.inputs = Array.prototype.slice.call(this.querySelectorAll('[data-hl-pattern-input]'));
      if (!this.choice || this.shots.length < 2 || this.inputs.length < 2) return;

      this.choice.hidden = false;

      var self = this;
      this.inputs.forEach(function (input) {
        input.addEventListener('change', function () {
          if (input.checked) self.zeige(input.value);
        });
      });
    }

    zeige(slot) {
      this.shots.forEach(function (shot) {
        var an = shot.getAttribute('data-hl-pattern-shot') === String(slot);
        shot.classList.toggle('is-current', an);
        /* Ausgeblendete Bilder sind fuer Vorleseprogramme nicht da - sonst
           laese jemand drei Bildbeschreibungen hintereinander, von denen
           zwei nicht zu sehen sind. */
        if (an) shot.removeAttribute('aria-hidden');
        else shot.setAttribute('aria-hidden', 'true');
      });
    }
  }

  if (!customElements.get('hl-pattern')) customElements.define('hl-pattern', HlPattern);
})();
